import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Minus } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    feature: 'Vleesgehalte',
    anifit: {
      status: 'good',
      text: '90-99% vleesgehalte'
    },
    regular: {
      status: 'bad',
      text: 'Max 30-60% vlees'
    },
    dry: {
      status: 'bad',
      text: 'Vaak 4-20% vlees'
    }
  }, {
    feature: 'Kwaliteit',
    anifit: {
      status: 'good',
      text: 'Levensmiddelkwaliteit vlees'
    },
    regular: {
      status: 'bad',
      text: 'Vaak vleesmeel/bijproducten'
    },
    dry: {
      status: 'bad',
      text: 'Meestal bijproducten en vulmiddelen'
    }
  }, {
    feature: 'Vochtgehalte',
    anifit: {
      status: 'good',
      text: 'Rijk aan natuurlijk vleesvocht'
    },
    regular: {
      status: 'neutral',
      text: 'Bevat vocht, minder vleesvocht'
    },
    dry: {
      status: 'bad',
      text: 'Onttrekt vocht aan het lichaam'
    }
  }, {
    feature: 'Celgezondheid',
    anifit: {
      status: 'good',
      text: 'Cellen stromen vrij door vleesvocht'
    },
    regular: {
      status: 'neutral',
      text: 'Deels ondersteunend'
    },
    dry: {
      status: 'bad',
      text: 'Cellen stromen slecht, veroorzaakt klachten'
    }
  }, {
    feature: 'Nier- en leverbelasting',
    anifit: {
      status: 'good',
      text: 'Gifstoffen worden makkelijk afgevoerd'
    },
    regular: {
      status: 'bad',
      text: 'Minder optimaal'
    },
    dry: {
      status: 'bad',
      text: 'Chronisch vochttekort belast organen'
    }
  }, {
    feature: 'Darmgezondheid',
    anifit: {
      status: 'good',
      text: 'Ondersteunt gezonde darmflora'
    },
    regular: {
      status: 'bad',
      text: 'Wisselend effect'
    },
    dry: {
      status: 'bad',
      text: '~80% honden heeft doffe buikpijn'
    }
  }, {
    feature: 'Conservering',
    anifit: {
      status: 'good',
      text: 'Geen conserveringsmiddelen'
    },
    regular: {
      status: 'bad',
      text: 'Conserveringsmiddelen nodig'
    },
    dry: {
      status: 'bad',
      text: 'Chemische conservering vereist'
    }
  }, {
    feature: 'Smaak',
    anifit: {
      status: 'good',
      text: 'Geen smaakversterkers'
    },
    regular: {
      status: 'bad',
      text: 'Lokstoffen toegevoegd'
    },
    dry: {
      status: 'bad',
      text: 'Vaak veel lokstoffen en vet-coating'
    }
  }, {
    feature: 'Koolhydraten',
    anifit: {
      status: 'good',
      text: 'Vlokken gepoft (verteerbaar)'
    },
    regular: {
      status: 'bad',
      text: 'Vaak onbewerkte granen'
    },
    dry: {
      status: 'bad',
      text: 'Hoog percentage onverteerbare granen'
    }
  }, {
    feature: 'Transparantie',
    anifit: {
      status: 'good',
      text: 'Exacte ingrediënten op etiket'
    },
    regular: {
      status: 'bad',
      text: 'Vage omschrijvingen'
    },
    dry: {
      status: 'bad',
      text: 'Onduidelijke samenstelling'
    }
  }, {
    feature: 'Herkomst',
    anifit: {
      status: 'good',
      text: 'Zweeds kwaliteitsvlees'
    },
    regular: {
      status: 'bad',
      text: 'Herkomst vaak onduidelijk'
    },
    dry: {
      status: 'bad',
      text: 'Herkomst zelden traceerbaar'
    }
  }];
  const getIcon = (status: string) => {
    switch (status) {
      case 'good':
        return <Check className="w-4 h-4 text-[#4DBFB8]" data-id="element-31" />;
      case 'neutral':
        return <Minus className="w-4 h-4 text-amber-500" data-id="element-32" />;
      case 'bad':
        return <X className="w-4 h-4 text-red-500" data-id="element-33" />;
      default:
        return null;
    }
  };
  const getIconBg = (status: string) => {
    switch (status) {
      case 'good':
        return 'bg-[#4DBFB8]/10';
      case 'neutral':
        return 'bg-amber-100';
      case 'bad':
        return 'bg-red-100';
      default:
        return 'bg-gray-100';
    }
  };
  return <section className="py-20 bg-gray-50" data-id="element-34">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-36">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-37">
            Anifit hondenvoer in vergelijking met regulier voer
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-38">
            Je hebt waarschijnlijk al gelezen over de voordelen. Hier de
            kernpunten op een rij:
          </p>
        </motion.div>

        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-39">
          <div className="grid grid-cols-4 bg-gray-900 text-white p-3 sm:p-4 text-xs sm:text-sm lg:text-base font-bold" data-id="element-40">
            <div className="text-gray-400 font-normal text-xs sm:text-sm flex items-center" data-id="element-41">
              KENMERK
            </div>
            <div className="text-[#4DBFB8] flex items-center justify-center text-center" data-id="element-42">
              ANIFIT
            </div>
            <div className="text-gray-400 flex items-center justify-center text-center" data-id="element-43">
              REGULIER NATVOER
            </div>
            <div className="text-gray-400 flex items-center justify-center text-center" data-id="element-44">
              BROKKEN
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-45">
            {comparisons.map((row, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="grid grid-cols-4 p-3 sm:p-4 hover:bg-gray-50 transition-colors" data-id="element-46">
                <div className="font-medium text-gray-900 flex items-center text-xs sm:text-sm lg:text-base pr-2" data-id="element-47">
                  {row.feature}
                </div>

                <div className="flex flex-col items-center justify-center text-center gap-1 sm:gap-2" data-id="element-48">
                  <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full ${getIconBg(row.anifit.status)} flex items-center justify-center flex-shrink-0`} data-id="element-49">
                    {getIcon(row.anifit.status)}
                  </div>
                  <span className="text-xs sm:text-sm text-gray-700 font-medium" data-id="element-50">
                    {row.anifit.text}
                  </span>
                </div>

                <div className="flex flex-col items-center justify-center text-center gap-1 sm:gap-2" data-id="element-51">
                  <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full ${getIconBg(row.regular.status)} flex items-center justify-center flex-shrink-0`} data-id="element-52">
                    {getIcon(row.regular.status)}
                  </div>
                  <span className="text-xs sm:text-sm text-gray-500" data-id="element-53">
                    {row.regular.text}
                  </span>
                </div>

                <div className="flex flex-col items-center justify-center text-center gap-1 sm:gap-2" data-id="element-54">
                  <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full ${getIconBg(row.dry.status)} flex items-center justify-center flex-shrink-0`} data-id="element-55">
                    {getIcon(row.dry.status)}
                  </div>
                  <span className="text-xs sm:text-sm text-gray-500" data-id="element-56">
                    {row.dry.text}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}